import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column m-0" }
const _hoisted_2 = {
  key: 0,
  class: "custom-route-error-color font-small"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  class: "col-11 m-0 position-relative input-col-10-padding",
  "data-bs-toggle": 'modal',
  "data-bs-target": '#picker-frequency'
}
const _hoisted_5 = ["placeholder", "value"]
const _hoisted_6 = { class: "d-flex flex-column align-items-center" }
const _hoisted_7 = { class: "modal-calendar-container d-flex flex-row" }
const _hoisted_8 = { id: "date-picker-date-1" }
const _hoisted_9 = { class: "d-flex display-days-container" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  class: "predefined-select-modal-container",
  id: "predefined-select-modal"
}
const _hoisted_13 = { class: "d-flex justify-content-center align-items-center h-100" }
const _hoisted_14 = ["value", "disabled"]
const _hoisted_15 = ["value"]
const _hoisted_16 = ["value"]
const _hoisted_17 = ["value"]
const _hoisted_18 = ["value"]
const _hoisted_19 = ["value"]
const _hoisted_20 = ["value"]
const _hoisted_21 = ["value"]
const _hoisted_22 = ["value"]
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "select-end-date-picker-cotainer__text" }
const _hoisted_25 = {
  class: "position-fixed user-defined-select-modal",
  id: "user-defined-select-modal"
}
const _hoisted_26 = { class: "container" }
const _hoisted_27 = { class: "user-defined-select-modal__container d-flex flex-row align-items-center mt-5" }
const _hoisted_28 = { class: "user-defined-select-modal__container__define-text" }
const _hoisted_29 = { class: "user-defined-select-modal__container__define-input" }
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "user-defined-select-modal__container__define-select" }
const _hoisted_32 = ["value"]
const _hoisted_33 = ["value"]
const _hoisted_34 = ["value"]
const _hoisted_35 = ["value"]
const _hoisted_36 = {
  key: 0,
  class: "select-week-day-wrapper"
}
const _hoisted_37 = { class: "select-week-day-wrapper__text" }
const _hoisted_38 = { class: "select-week-day-wrapper__items d-flex" }
const _hoisted_39 = ["for"]
const _hoisted_40 = ["id", "value", "disabled"]
const _hoisted_41 = { class: "select-end-date-picker-cotainer" }
const _hoisted_42 = { class: "select-end-date-picker-cotainer__text" }
const _hoisted_43 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatepickerComponent = _resolveComponent("DatepickerComponent")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.isValid.state)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t(_ctx.isValid.message)), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.backendValidationErrors, (error) => {
        return (_openBlock(), _createElementBlock("span", {
          class: "custom-route-error-color font-small",
          key: error
        }, _toDisplayString(_ctx.$t(error)), 1))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "col-1 m-0" }, null, -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("input", {
          class: "custom-select-frequency",
          id: "picker-frequency-date",
          placeholder: _ctx.$t('select_frequency_of_journey'),
          value: _ctx.store.state.orderTrueDriverDates.selectedPredefinedOption === _ctx.selectPredefinedOptionsConstants.USER_DEFINED ?
          this.store.state.orderTrueDriverDates.translatedSelectedDateText : _ctx.buildPredefinedSelectionString(_ctx.store.state.orderTrueDriverDates.selectedPredefinedOption)
        }, null, 8, _hoisted_5),
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "arrow-select position-absolute icon-calender-position" }, [
          _createElementVNode("img", { src: "/assets/images/calendar-calendar-1.svg" })
        ], -1))
      ])
    ]),
    _createVNode(_component_ModalComponent, {
      "id-data": 'picker-frequency',
      "modal-title": _ctx.$t('select_frequency_of_journey')
    }, {
      "body-content": _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_DatepickerComponent, {
                monthNameFormat: "long",
                id: "picker-main",
                ref: "datepickerMain",
                locale: _ctx.store.state.general.locale,
                minDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1),
                inline: "",
                "auto-apply": "",
                "multi-dates": true,
                highlightDisabledDays: "",
                enableTimePicker: false,
                modelValue: _ctx.selectedDates,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectDate($event))),
                onInternalModelChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.internalModelChange($event)))
              }, null, 8, ["locale", "minDate", "modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('day_count_selected')), 1),
            (_ctx.selectedDates)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(this.selectedDates.length === 1 ? this.selectedDates.length : this.selectedDates.length - 1), 1))
              : _createCommentVNode("", true),
            (!_ctx.selectedDates)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 0 "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("select", {
                value: !_ctx.isCustomOption ? _ctx.store.state.orderTrueDriverDates.selectedPredefinedOption : _ctx.selectPredefinedOptionsConstants.USER_DEFINED,
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectPredefinedOption($event))),
                class: "select-predefine-container",
                disabled: _ctx.isDisabledSelect
              }, [
                _createElementVNode("option", {
                  value: _ctx.selectPredefinedOptionsConstants.CHOOSE,
                  disabled: "",
                  selected: []
                }, _toDisplayString(_ctx.buildPredefinedSelectionString(_ctx.selectPredefinedOptionsConstants.CHOOSE)), 9, _hoisted_15),
                _createElementVNode("option", {
                  value: _ctx.selectPredefinedOptionsConstants.NOT_REPEAT
                }, _toDisplayString(_ctx.buildPredefinedSelectionString(_ctx.selectPredefinedOptionsConstants.NOT_REPEAT)), 9, _hoisted_16),
                _createElementVNode("option", {
                  value: _ctx.selectPredefinedOptionsConstants.DAILY
                }, _toDisplayString(_ctx.buildPredefinedSelectionString(_ctx.selectPredefinedOptionsConstants.DAILY)), 9, _hoisted_17),
                _createElementVNode("option", {
                  value: _ctx.selectPredefinedOptionsConstants.WEEKLY
                }, _toDisplayString(_ctx.buildPredefinedSelectionString(_ctx.selectPredefinedOptionsConstants.WEEKLY)), 9, _hoisted_18),
                _createElementVNode("option", {
                  value: _ctx.selectPredefinedOptionsConstants.MONTHLY
                }, _toDisplayString(_ctx.buildPredefinedSelectionString(_ctx.selectPredefinedOptionsConstants.MONTHLY)), 9, _hoisted_19),
                _createElementVNode("option", {
                  value: _ctx.selectPredefinedOptionsConstants.ANNUALLY
                }, _toDisplayString(_ctx.buildPredefinedSelectionString(_ctx.selectPredefinedOptionsConstants.ANNUALLY)), 9, _hoisted_20),
                _createElementVNode("option", {
                  value: _ctx.selectPredefinedOptionsConstants.WEEKDAY
                }, _toDisplayString(_ctx.buildPredefinedSelectionString(_ctx.selectPredefinedOptionsConstants.WEEKDAY)), 9, _hoisted_21),
                (_ctx.isCustomOption)
                  ? (_openBlock(), _createElementBlock("option", {
                      key: 0,
                      value: _ctx.selectPredefinedOptionsConstants.USER_DEFINED
                    }, _toDisplayString(this.store.state.orderTrueDriverDates.translatedSelectedDateText), 9, _hoisted_22))
                  : _createCommentVNode("", true),
                _createElementVNode("option", {
                  value: _ctx.selectPredefinedOptionsConstants.CUSTOM
                }, _toDisplayString(_ctx.$t('custom')), 9, _hoisted_23)
              ], 40, _hoisted_14)
            ])
          ]),
          _createElementVNode("div", {
            class: "select-end-date-picker-cotainer d-flex align-items-center mb-4",
            style: _normalizeStyle({display: !_ctx.isCustomOption ? 'block' : 'none!important'})
          }, [
            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('ends')), 1),
            _createVNode(_component_DatepickerComponent, {
              monthNameFormat: "long",
              "auto-apply": "",
              closeOnAutoApply: true,
              locale: _ctx.store.state.general.locale,
              multiDates: false,
              minDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1),
              enableTimePicker: false,
              modelValue: _ctx.endDate,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.endDate) = $event)),
              id: "picker-end-date-second",
              ref: "datepicker-end-date-second"
            }, null, 8, ["locale", "minDate", "modelValue"])
          ], 4),
          _createVNode(_component_ButtonComponent, {
            type: "button",
            "data-bs-target": "#picker-frequency",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _ctx.submit,
            class: _normalizeClass(["m-0", {'calendar-select-disabled-button' : _ctx.isDisabledSelect, 'calendar-select-submit-button' : !_ctx.isDisabledSelect}]),
            disabled: _ctx.isDisabledSelect
          }, {
            btnContent: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('select')), 1)
            ]),
            _: 1
          }, 8, ["onClick", "class", "disabled"])
        ])
      ]),
      _: 1
    }, 8, ["modal-title"]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('repeat_every')), 1),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("input", {
                class: "input-user-predefine-container",
                type: "number",
                min: "1",
                value: _ctx.store.state.orderTrueDriverDates.period,
                onChange: _cache[4] || (_cache[4] = event => _ctx.store.dispatch('orderTrueDriverDates/updateState', [{prop: 'period', value: parseInt(event.target.value)}]))
              }, null, 40, _hoisted_30)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.store.state.orderTrueDriverDates.selectedPeriodType) = $event)),
                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectPeriodType($event))),
                class: "select-default-container"
              }, [
                _createElementVNode("option", {
                  value: _ctx.selectDefaultPeriodTypeConstants.DAY,
                  selected: ""
                }, _toDisplayString(_ctx.store.state.orderTrueDriverDates.period === 1 ? _ctx.$t('day_1')  : _ctx.$t('day_2')), 9, _hoisted_32),
                _createElementVNode("option", {
                  value: _ctx.selectDefaultPeriodTypeConstants.WEEK
                }, _toDisplayString(_ctx.store.state.orderTrueDriverDates.period === 1 ? _ctx.$t('week_1')  : _ctx.$t('week_2')), 9, _hoisted_33),
                _createElementVNode("option", {
                  value: _ctx.selectDefaultPeriodTypeConstants.MONTH
                }, _toDisplayString(_ctx.store.state.orderTrueDriverDates.period === 1 ? _ctx.$t('month_1')  : _ctx.$t('month_2')), 9, _hoisted_34),
                _createElementVNode("option", {
                  value: _ctx.selectDefaultPeriodTypeConstants.YEAR
                }, _toDisplayString(_ctx.store.state.orderTrueDriverDates.period === 1 ? _ctx.$t('year_1')  : _ctx.$t('year_2')), 9, _hoisted_35)
              ], 544), [
                [_vModelSelect, _ctx.store.state.orderTrueDriverDates.selectedPeriodType]
              ])
            ])
          ]),
          (_ctx.store.state.orderTrueDriverDates.selectedPeriodType === _ctx.selectDefaultPeriodTypeConstants.WEEK)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('repeat_on')), 1),
                _createElementVNode("div", _hoisted_38, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekDays, (day) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: day.id + 1,
                      class: "select-week-day-wrapper__items__item d-flex align-items-center"
                    }, [
                      _createElementVNode("label", {
                        for: day.name + day.id,
                        class: "select-week-day-wrapper__items__item__label"
                      }, _toDisplayString(_ctx.$t(day.name)[0]), 9, _hoisted_39),
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: day.name + day.id,
                        value: day.id,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedDays) = $event)),
                        disabled: day.id === _ctx.store.state.orderTrueDriverDates.selectedDays[0] && _ctx.store.state.orderTrueDriverDates.selectedDays.length === 1
                      }, null, 8, _hoisted_40), [
                        [_vModelCheckbox, _ctx.selectedDays]
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('ends')), 1),
            _createVNode(_component_DatepickerComponent, {
              monthNameFormat: "long",
              "auto-apply": "",
              closeOnAutoApply: true,
              locale: _ctx.store.state.general.locale,
              multiDates: false,
              minDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1),
              enableTimePicker: false,
              modelValue: _ctx.endDate,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.endDate) = $event)),
              id: "picker-end-date",
              ref: "datepicker-end-date"
            }, null, 8, ["locale", "minDate", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("button", {
              class: "select-user-defined-option-submit-button",
              type: "submit",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.calculateAllSelectedDates([_ctx.store.state.orderTrueDriverDates.selectedStartDate], _ctx.store.state.orderTrueDriverDates.selectedPeriodType)))
            }, _toDisplayString(_ctx.$t('save')), 1)
          ]),
          _createElementVNode("button", {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$helpers.closeModal({
            id: 'user-defined-select-modal',
            backdrop: 'custom-modal-backdrop-1',
            bodyOverflow: 'body-overflow'
          }), _ctx.selectDate([_ctx.store.state.orderTrueDriverDates.selectedStartDate]))),
            class: "custom-button modal-close-button"
          }, _cache[13] || (_cache[13] = [
            _createElementVNode("span", null, [
              _createElementVNode("img", {
                src: "/assets/images/xTimes-1.svg",
                alt: "times"
              })
            ], -1)
          ]))
        ])
      ])
    ]))
  ], 64))
}